module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/colourCustomerTopBg-5566be2bad4aab89e278f2abb588a640.png";